module.exports = __webpack_public_path__ + "img/202412180101.161bfd19.png";